import _regeneratorRuntime from "@babel/runtime/regenerator";
import _extends from "@babel/runtime/helpers/extends";

var _marked =
/*#__PURE__*/
_regeneratorRuntime.mark(getRequestInstance),
    _marked2 =
/*#__PURE__*/
_regeneratorRuntime.mark(sendRequest),
    _marked3 =
/*#__PURE__*/
_regeneratorRuntime.mark(cancelSendRequestOnAction),
    _marked4 =
/*#__PURE__*/
_regeneratorRuntime.mark(watchRequests);

import { call, fork, join, take, race, cancel, put, all, cancelled, getContext, setContext } from 'redux-saga/effects';
import { delay } from 'redux-saga';
import { createSuccessAction, createErrorAction, createAbortAction, getActionPayload, isRequestAction } from './actions';
import { REQUESTS_CONFIG, INCORRECT_PAYLOAD_ERROR } from './constants';
export var voidCallback = function voidCallback() {};
export var defaultConfig = {
  driver: null,
  onRequest: null,
  onSuccess: null,
  onError: null,
  onAbort: null
};
export function createRequestInstance(config) {
  var _setContext;

  return setContext((_setContext = {}, _setContext[REQUESTS_CONFIG] = _extends({}, defaultConfig, config), _setContext));
}
export function getRequestsConfig() {
  return getContext(REQUESTS_CONFIG);
}
export function getRequestInstance(driverType) {
  var config, driver;
  return _regeneratorRuntime.wrap(function getRequestInstance$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          if (driverType === void 0) {
            driverType = null;
          }

          _context.next = 3;
          return getRequestsConfig();

        case 3:
          config = _context.sent;
          driver = driverType ? config.driver[driverType] : config.driver.default || config.driver;
          return _context.abrupt("return", driver.requestInstance);

        case 6:
        case "end":
          return _context.stop();
      }
    }
  }, _marked, this);
}

var getDriver = function getDriver(requestsConfig, action) {
  return action.meta && action.meta.driver ? requestsConfig.driver[action.meta.driver] : requestsConfig.driver.default || requestsConfig.driver;
};

export function sendRequest(action, _temp) {
  var _ref, _ref$dispatchRequestA, dispatchRequestAction, _ref$silent, silent, _ref$runOnRequest, runOnRequest, _ref$runOnSuccess, runOnSuccess, _ref$runOnError, runOnError, _ref$runOnAbort, runOnAbort, requestsConfig, driver, actionPayload, abortSource, response, responseError, _ref2, onErrorResponse, onErrorError, errorPayload, successPayload;

  return _regeneratorRuntime.wrap(function sendRequest$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _ref = _temp === void 0 ? {} : _temp, _ref$dispatchRequestA = _ref.dispatchRequestAction, dispatchRequestAction = _ref$dispatchRequestA === void 0 ? false : _ref$dispatchRequestA, _ref$silent = _ref.silent, silent = _ref$silent === void 0 ? false : _ref$silent, _ref$runOnRequest = _ref.runOnRequest, runOnRequest = _ref$runOnRequest === void 0 ? true : _ref$runOnRequest, _ref$runOnSuccess = _ref.runOnSuccess, runOnSuccess = _ref$runOnSuccess === void 0 ? true : _ref$runOnSuccess, _ref$runOnError = _ref.runOnError, runOnError = _ref$runOnError === void 0 ? true : _ref$runOnError, _ref$runOnAbort = _ref.runOnAbort, runOnAbort = _ref$runOnAbort === void 0 ? true : _ref$runOnAbort;

          if (isRequestAction(action)) {
            _context2.next = 3;
            break;
          }

          throw new Error(INCORRECT_PAYLOAD_ERROR);

        case 3:
          _context2.next = 5;
          return getRequestsConfig();

        case 5:
          requestsConfig = _context2.sent;

          if (!(dispatchRequestAction && !silent)) {
            _context2.next = 9;
            break;
          }

          _context2.next = 9;
          return put(action);

        case 9:
          _context2.next = 11;
          return call(getDriver, requestsConfig, action);

        case 11:
          driver = _context2.sent;
          actionPayload = getActionPayload(action);

          if (!(requestsConfig.onRequest && runOnRequest)) {
            _context2.next = 17;
            break;
          }

          _context2.next = 16;
          return call(requestsConfig.onRequest, actionPayload.request, action);

        case 16:
          actionPayload.request = _context2.sent;

        case 17:
          abortSource = driver.getAbortSource();
          _context2.prev = 18;
          _context2.prev = 19;

          if (Array.isArray(actionPayload.request)) {
            _context2.next = 26;
            break;
          }

          _context2.next = 23;
          return call([driver, 'sendRequest'], actionPayload.request, abortSource, action);

        case 23:
          response = _context2.sent;
          _context2.next = 29;
          break;

        case 26:
          _context2.next = 28;
          return all(actionPayload.request.map(function (requestItem) {
            return call([driver, 'sendRequest'], requestItem, abortSource, action);
          }));

        case 28:
          response = _context2.sent;

        case 29:
          _context2.next = 34;
          break;

        case 31:
          _context2.prev = 31;
          _context2.t0 = _context2["catch"](19);
          responseError = _context2.t0;

        case 34:
          if (!responseError) {
            _context2.next = 50;
            break;
          }

          if (!(requestsConfig.onError && runOnError)) {
            _context2.next = 42;
            break;
          }

          _context2.next = 38;
          return call(requestsConfig.onError, responseError, action);

        case 38:
          _ref2 = _context2.sent;
          onErrorResponse = _ref2.response;
          onErrorError = _ref2.error;

          if (onErrorResponse) {
            response = onErrorResponse;
          } else {
            responseError = onErrorError;
          }

        case 42:
          if (response) {
            _context2.next = 50;
            break;
          }

          _context2.next = 45;
          return call(driver.getErrorPayload, responseError);

        case 45:
          errorPayload = _context2.sent;

          if (silent) {
            _context2.next = 49;
            break;
          }

          _context2.next = 49;
          return put(createErrorAction(action, errorPayload));

        case 49:
          return _context2.abrupt("return", {
            error: responseError
          });

        case 50:
          if (!(requestsConfig.onSuccess && runOnSuccess)) {
            _context2.next = 54;
            break;
          }

          _context2.next = 53;
          return call(requestsConfig.onSuccess, response, action);

        case 53:
          response = _context2.sent;

        case 54:
          _context2.next = 56;
          return call(driver.getSuccessPayload, response, actionPayload.request);

        case 56:
          successPayload = _context2.sent;

          if (silent) {
            _context2.next = 60;
            break;
          }

          _context2.next = 60;
          return put(createSuccessAction(action, successPayload));

        case 60:
          return _context2.abrupt("return", {
            response: response
          });

        case 61:
          _context2.prev = 61;
          _context2.next = 64;
          return cancelled();

        case 64:
          if (!_context2.sent) {
            _context2.next = 73;
            break;
          }

          _context2.next = 67;
          return call([driver, 'abortRequest'], abortSource);

        case 67:
          if (!(requestsConfig.onAbort && runOnAbort)) {
            _context2.next = 70;
            break;
          }

          _context2.next = 70;
          return call(requestsConfig.onAbort, action);

        case 70:
          if (silent) {
            _context2.next = 73;
            break;
          }

          _context2.next = 73;
          return put(createAbortAction(action));

        case 73:
          return _context2.finish(61);

        case 74:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2, this, [[18,, 61, 74], [19, 31]]);
}

var isGetRequest = function isGetRequest(request) {
  return !request.method || request.method.toLowerCase() === 'get';
};

var watchRequestsDefaultConfig = {
  takeLatest: function takeLatest(action) {
    var _getActionPayload = getActionPayload(action),
        request = _getActionPayload.request;

    return Array.isArray(request) ? request.every(isGetRequest) : isGetRequest(request);
  },
  abortOn: null,
  getLastActionKey: function getLastActionKey(action) {
    return action.type;
  }
};
export function cancelSendRequestOnAction(abortOn, task) {
  var _ref3, abortingAction;

  return _regeneratorRuntime.wrap(function cancelSendRequestOnAction$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return race({
            abortingAction: take(abortOn),
            taskFinished: join(task),
            timeout: call(delay, 10000) // taskFinished doesnt work for aborted tasks

          });

        case 2:
          _ref3 = _context3.sent;
          abortingAction = _ref3.abortingAction;

          if (!abortingAction) {
            _context3.next = 7;
            break;
          }

          _context3.next = 7;
          return cancel(task);

        case 7:
        case "end":
          return _context3.stop();
      }
    }
  }, _marked3, this);
}
export function watchRequests(common, perRequestType) {
  var lastTasks, config, action, localConfig, lastActionKey, takeLatest, activeTask, newTask;
  return _regeneratorRuntime.wrap(function watchRequests$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          if (common === void 0) {
            common = {};
          }

          if (perRequestType === void 0) {
            perRequestType = {};
          }

          lastTasks = {};
          config = _extends({}, watchRequestsDefaultConfig, common);

        case 4:
          if (!true) {
            _context4.next = 25;
            break;
          }

          _context4.next = 7;
          return take(isRequestAction);

        case 7:
          action = _context4.sent;
          localConfig = perRequestType[action.type] ? _extends({}, config, perRequestType[action.type]) : config;
          lastActionKey = localConfig.getLastActionKey(action);
          takeLatest = typeof localConfig.takeLatest === 'function' ? localConfig.takeLatest(action) : localConfig.takeLatest;

          if (!takeLatest) {
            _context4.next = 16;
            break;
          }

          activeTask = lastTasks[lastActionKey];

          if (!activeTask) {
            _context4.next = 16;
            break;
          }

          _context4.next = 16;
          return cancel(activeTask);

        case 16:
          _context4.next = 18;
          return fork(sendRequest, action);

        case 18:
          newTask = _context4.sent;

          if (takeLatest) {
            lastTasks[lastActionKey] = newTask;
          }

          if (!localConfig.abortOn) {
            _context4.next = 23;
            break;
          }

          _context4.next = 23;
          return fork(cancelSendRequestOnAction, localConfig.abortOn, newTask);

        case 23:
          _context4.next = 4;
          break;

        case 25:
        case "end":
          return _context4.stop();
      }
    }
  }, _marked4, this);
}